import React from 'react';
import { formatNumber } from '../../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

const useStyles = makeStyles((theme: any) => ({
  stageAmount: { display: 'flex', alignItems: 'center' },
  moneyIcon: {
    color: theme.palette.brand.greenNature,
    fontSize: theme.spacing(2.5),
  },
}));
export default function MobileStageAmount({ amount }: { amount: number }) {
  const classes = useStyles();
  const formattedAmount = amount ? formatNumber(amount) : '0.00';
  return (
    <div className={classes.stageAmount}>
      <AttachMoneyIcon className={classes.moneyIcon} />
      <Typography>{formattedAmount}</Typography>
    </div>
  );
}
